<template>
  <div class="merchandising-configuration">
    <vx-card title="Merchandising Configuration" class="merch-config-page-card">
      <div class="list-toolbar mb-4">
        <vs-button
          color="primary"
          icon-pack="feather"
          icon="icon-plus"
          @click="handleCreate"
        >
          Create
        </vs-button>
      </div>

      <div class="filter-inline mb-6">
        <div class="filter-field">
          <label class="vs-input--label">Merchandising ID</label>
          <vs-input
            v-model="filterMerchandisingId"
            placeholder="Default ALL"
            class="w-full"
          />
        </div>
        <div class="filter-field">
          <label class="vs-input--label">Territory</label>
          <multiselect
            class="selectExample"
            v-model="filterTerritory"
            :options="optionTerritory"
            :multiple="false"
            :allow-empty="true"
            :show-labels="false"
            :max-height="160"
            placeholder="Default ALL"
            track-by="id"
            :internal-search="false"
            :searchable="true"
            @search-change="handlerSearchTerritory"
            :custom-label="customLabelTerritory"
          />
        </div>
        <div class="filter-actions">
          <vs-button
            color="primary"
            icon-pack="feather"
            icon="icon-filter"
            @click="handleFilter"
          >
            Filter
          </vs-button>
        </div>
      </div>

      <vs-tabs v-model="activeTabIndex">
        <vs-tab label="New" @click="setStatusTab('new')">
          <div class="tab-text">
            <data-table
              v-if="statusTab === 'new'"
              status-tab="new"
              :territory-id="appliedTerritoryId"
              :merchandising-id-filter="appliedMerchandisingId"
              :refresh-key="refreshKey"
            />
          </div>
        </vs-tab>
        <vs-tab label="Released" @click="setStatusTab('released')">
          <div class="tab-text">
            <data-table
              v-if="statusTab === 'released'"
              status-tab="released"
              :territory-id="appliedTerritoryId"
              :merchandising-id-filter="appliedMerchandisingId"
              :refresh-key="refreshKey"
            />
          </div>
        </vs-tab>
        <vs-tab label="Canceled" @click="setStatusTab('canceled')">
          <div class="tab-text">
            <data-table
              v-if="statusTab === 'canceled'"
              status-tab="canceled"
              :territory-id="appliedTerritoryId"
              :merchandising-id-filter="appliedMerchandisingId"
              :refresh-key="refreshKey"
            />
          </div>
        </vs-tab>
        <vs-tab label="Expired" @click="setStatusTab('expired')">
          <div class="tab-text">
            <data-table
              v-if="statusTab === 'expired'"
              status-tab="expired"
              :territory-id="appliedTerritoryId"
              :merchandising-id-filter="appliedMerchandisingId"
              :refresh-key="refreshKey"
            />
          </div>
        </vs-tab>
      </vs-tabs>

      <div class="page-footer-actions mt-6">
        <vs-button type="border" color="danger" @click="handleClose">
          Close
        </vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
import DataTable from "./DataTable.vue";
import { TERRITORY_URL, formatTerritoryLabel } from "./api";

export default {
  name: "MerchandisingConfigurationIndex",
  components: {
    DataTable,
  },
  data() {
    return {
      activeTabIndex: 0,
      statusTab: "new",
      filterMerchandisingId: "",
      filterTerritory: null,
      appliedMerchandisingId: "",
      appliedTerritoryId: null,
      refreshKey: 0,
      optionTerritory: [],
      searchTerritory: "",
    };
  },
  methods: {
    customLabelTerritory: formatTerritoryLabel,
    setStatusTab(tab) {
      this.statusTab = tab;
    },
    handleFilter() {
      this.appliedMerchandisingId = (this.filterMerchandisingId || "").trim();
      this.appliedTerritoryId = this.filterTerritory
        ? this.filterTerritory.id
        : null;
      this.refreshKey += 1;
    },
    handleCreate() {
      this.$router.push({ name: "merchandising-configuration-create" });
    },
    handleClose() {
      this.$router.push({ name: "home" });
    },
    handlerSearchTerritory(query) {
      this.searchTerritory = query;
      this.getTerritory();
    },
    getTerritory() {
      this.$http
        .get(TERRITORY_URL, { params: { search: this.searchTerritory } })
        .then((resp) => {
          if (resp.code === 200 && resp.data && resp.data.records) {
            this.optionTerritory = resp.data.records;
          } else {
            this.optionTerritory = [];
          }
        })
        .catch(() => {
          this.optionTerritory = [];
        });
    },
  },
  mounted() {
    this.getTerritory();
  },
};
</script>

<style scoped>
.filter-inline {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
}

.filter-field {
  flex: 1 1 220px;
  min-width: 200px;
}

.filter-actions {
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  padding-bottom: 2px;
}

.page-footer-actions {
  text-align: left;
}
</style>
